import React from 'react'
import { MoonLoader } from 'react-spinners'
import './style.scss'

export const TableLoader = () => {
    return(
        <div className="lsdrf-table-loader-wrap">
            <div className="ldsrf-table-spinner">
                <MoonLoader
                    size={40}
                    color={"#4CA1F1"}
                    loading={true}
                />
            </div>
            <h4 className="loading-label">Laster..</h4>
        </div>
    )
}